module.exports = __webpack_public_path__ + "static/TheClassyNurse-9caccf09302e3a414a5eacf52109030f.jpeg";